// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"9b49b3f6","90":"0cd620a0","227":"48b2f878","373":"616f534e","410":"bd1242f9","453":"372bff61","455":"e7c37acd","477":"fc8c3dd7","609":"e685f483","673":"db575445","675":"45964c6d","732":"19d63a49","782":"9fe808e6","815":"f5a12ad1","874":"efe2b427","977":"ec947930"}[chunkId] + ".chunk.js";
};